import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M15.56 3.65a.971.971 0 0 0 0-1.367.955.955 0 0 0-1.358 0l-2.611 2.63a.967.967 0 0 0-.28.717.967.967 0 0 0 .28.717l2.611 2.63a.955.955 0 0 0 1.357 0 .971.971 0 0 0 0-1.367l-1.034-1.04 5.874.018c3.464.01 6.269 2.835 6.28 6.323l.023 8.139a.963.963 0 0 0 .963.963.963.963 0 0 0 .957-.969l-.025-8.138c-.013-4.552-3.673-8.238-8.193-8.251l-5.825-.018.98-.986z"></path><path fill-rule="evenodd" d="M3.378 13.74c0-.91.733-1.648 1.637-1.648h14.51c.903 0 1.636.738 1.636 1.648v14.612c0 .91-.733 1.648-1.637 1.648H5.014a1.642 1.642 0 0 1-1.636-1.648V13.74zm1.919 14.327V14.025h13.945v14.042H5.297z" clip-rule="evenodd"></path>';
export var RotateCounterClockwiseOutlineSVG = function RotateCounterClockwiseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
RotateCounterClockwiseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(RotateCounterClockwiseOutlineSVG);